
















































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component } from 'vue-property-decorator';
import {
  AlignJustifyIcon,
  EyeIcon,
  EyeOffIcon,
  HelpCircleIcon,
  LogOutIcon,
  MoonIcon,
  NavigationIcon,
  SettingsIcon,
  SunIcon,
} from 'vue-feather-icons';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import Avatar from '@/components/common/Avatar.vue';
import { PreferencesAction } from '@/store/PreferencesModule';
import TourModal from '@/modals/TourModal.vue';
import { UserStatus } from 'admiral-core';
import { BModal } from 'bootstrap-vue';

@Component({
  components: {
    TourModal,
    Avatar,
    EyeIcon,
    EyeOffIcon,
    MoonIcon,
    SunIcon,
    HelpCircleIcon,
    SettingsIcon,
    AlignJustifyIcon,
    NavigationIcon,
    LogOutIcon,
  },
})
export default class UserMenuDropdown extends mixins(BaseMixin) {
  async mounted() {
    this.openTourModal();
  }

  openTourModal(force = false) {
    if (this.user.status === UserStatus.FIRST_LOGIN || force) {
      ((this.$refs['tour-modal'] as TourModal).$refs['tour'] as BModal).show();
    }
  }
  async toggleDarkMode() {
    await this.$store.dispatch(
      `PreferencesModule/${PreferencesAction.updateDarkMode}`,
      !this.isDarkMode,
    );

    if (this.isDarkMode) {
      document.body.classList.add('dark-layout');
    } else {
      document.body.classList.remove('dark-layout');
    }
  }
  get userStatus() {
    return this.$store.getters['socketConnection/isConnected'] ? 'online' : 'offline';
  }
}
